import { Divider, Paper, Typography } from "@mui/material";
import React from "react";

interface ProfileDataCardProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
}

/**
 * This component displays a card with a title and children.
 * @param title The title of the card.
 * @param children The children of the card.
 * @returns A card with a title and children.
 */
const ProfileDataCard = ({ title, children }: ProfileDataCardProps) => {
  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        border: 1,
        borderColor: "#C4c4c4",
        borderRadius: 2,
        padding: 2,
      }}
      elevation={1}
    >
      <Typography fontWeight={"bold"} fontSize={20}>
        {title}
      </Typography>
      <Divider sx={{ mb: 1 }} />
      {children}
    </Paper>
  );
};

export default ProfileDataCard;
